import { render, staticRenderFns } from "./AdminDashboardFunding.vue?vue&type=template&id=48c05424&"
import script from "./AdminDashboardFunding.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardFunding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports